import React from 'react';
import { useApp } from '../context/AppContext';
import { money } from '../lib/constants';
import { findNeighborhood } from '../lib/deliveryPricing';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const NeighborhoodSelect = ({ destination, onChange, testId }) => {
  const { coverage, deliveryPricing, pricingReady } = useApp();
  const zone = findNeighborhood(coverage, destination);
  const choose = (id) => {
    const selected = coverage.find((c) => c.id === id);
    onChange({ coverageId: selected?.id || null, barrio: selected?.barrio || '', city: selected?.city || '' });
  };
  return (
    <div className="space-y-1.5 min-w-0">
      <label htmlFor={`${testId}-trigger`} className="text-xs font-semibold text-gray-600">Barrio / colonia de entrega</label>
      <Select value={zone?.id || 'default'} onValueChange={choose} disabled={!pricingReady}>
        <SelectTrigger id={`${testId}-trigger`} data-testid={`${testId}-trigger`} className="w-full min-w-0 h-auto min-h-11 text-left whitespace-normal [&>span]:min-w-0 [&>span]:break-words [&>span]:line-clamp-none"><SelectValue placeholder="Barrio / colonia" /></SelectTrigger>
        <SelectContent data-testid={`${testId}-options`} className="w-[var(--radix-select-trigger-width)] max-w-[calc(100vw-40px)] [&_[role=option]>span:last-child]:min-w-0 [&_[role=option]>span:last-child]:break-words">
          <SelectItem data-testid={`${testId}-default`} value="default">Otra dirección · +{money(deliveryPricing?.defaultNeighborhoodFee)}</SelectItem>
          {coverage.filter((c) => c.active).map((c) => <SelectItem data-testid={`${testId}-option-${c.id}`} key={c.id} value={c.id} className="break-words">{c.barrio} ({c.city}) · +{money(c.deliveryFee ?? deliveryPricing?.defaultNeighborhoodFee)}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
};